import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vu_admin_token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// Auto-logout on 401 for admin-protected calls
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const token = localStorage.getItem("vu_admin_token");
    if (status === 401 && token && !url.includes("/admin/login")) {
      // Token expired or invalid - clear and reload if on admin page
      localStorage.removeItem("vu_admin_token");
      localStorage.removeItem("vu_admin_email");
      if (window.location.pathname.startsWith("/admin")) {
        // soft reload the admin page to force relogin
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export const CLUB_LOGO =
  "https://customer-assets-agu9un31.emergentagent.net/job_club-infos/artifacts/c88dd44ea1b145b0_IMG_1314.png";

export const COLORS = {
  primary: "#1E3A8A",
  primaryHover: "#1E40AF",
  gold: "#D97706",
  red: "#DC2626",
  text: "#0F172A",
  muted: "#475569",
  border: "#E2E8F0",
  surface: "#F8FAFC",
};
